module.exports = __webpack_public_path__ + "img/view.755ef1a4.svg";